"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentTypeMapper = void 0;
const enum_mapper_1 = require("../utils/enum-mapper");
const api_types_1 = require("@wix/wix-vod-constants/api-types");
const globalTypes_1 = require("../public/generated/globalTypes");
exports.paymentTypeMapper = new enum_mapper_1.EnumMapper({
    [globalTypes_1.PurchaseOrderType.RENT]: api_types_1.PaymentType.RENT,
    [globalTypes_1.PurchaseOrderType.SALE]: api_types_1.PaymentType.PURCHASE,
    [globalTypes_1.PurchaseOrderType.SUBSCRIPTION]: api_types_1.PaymentType.SUBSCRIPTION,
});
//# sourceMappingURL=payment-type.js.map